module.exports = __webpack_public_path__ + "img/header-engagementRingsEntwined@2x.ba9ff14.webp";